/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hub_Matrix_TitleInputs */

const en_hub_matrix_title = /** @type {(inputs: Hub_Matrix_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One plan, every format`)
};

const id_hub_matrix_title = /** @type {(inputs: Hub_Matrix_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satu rencana, semua format`)
};

/**
* | output |
* | --- |
* | "One plan, every format" |
*
* @param {Hub_Matrix_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const hub_matrix_title = /** @type {((inputs?: Hub_Matrix_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hub_Matrix_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_hub_matrix_title(inputs)
	return en_hub_matrix_title(inputs)
});